/** Safe in-app return path from navigate state (notify inbox · peek MX4). */

export function readReturnTo(state: unknown): string | null {
  if (!state || typeof state !== "object") return null;
  const raw = (state as { returnTo?: unknown; from?: unknown }).returnTo
    ?? (state as { from?: unknown }).from;
  if (typeof raw !== "string") return null;
  const rt = raw.trim();
  if (!rt.startsWith("/")) return null;
  if (rt.includes("://") || rt.includes("\\") || rt.startsWith("//")) return null;
  if (
    rt.startsWith("/field") ||
    rt.startsWith("/ops") ||
    rt.startsWith("/exe")
  ) {
    return rt;
  }
  return null;
}
